import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Table, Button, Form, Input, Select, Popover, Radio, Spin, InputNumber, Space, DatePicker, Cascader } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, AuditOutlined, RollbackOutlined, CheckOutlined } from '@ant-design/icons';
import Message from '../../component/message/message';
import moment from 'moment';//日期格式化导包
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import UploadModal from './uploadModal';
import SelectProgModal from '../../component/selectProgModal/selectProgModal';
import SelectStudentModal from './selectStudentModal';
import { useLocation } from 'react-router-dom';

import trans from './translation';
import './jobManagement.css';

const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;
const ClassicEditor = window.ClassicEditor;


const JobManagement = (props) => {
    const messageRef = useRef();
    const [form] = Form.useForm();
    const jobTypeId = Form.useWatch('jobType', form);
    const [tabIndex, setTabIndex] = useState("1");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [deleteTipText, setDeleteTipText] = useState("");
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState(useLocation().model ?? {});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [isUpload, setIsUpload] = useState(false);
    const [workLocList, setWorkLocList] = useState([]);
    const [applyMethodList, setApplyMethodList] = useState([]);
    const [positionTypeList, setPositionTypeList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [typeList, setTypeList] = useState([]);

    const [isCohortProgModal, setIsCohortProgModal] = useState(false);
    const [cohortProgModel, setCohortProgModel] = useState({});
    const [jobPostStatus, setJobPostStatus] = useState("");
    const [jobPostModel, setJobPostModel] = useState({});
    const [isDisabled, setIsDisabled] = useState(false);
    const [isCohortProgModal2, setIsCohortProgModal2] = useState(false);
    const [cohortProgModel2, setCohortProgModel2] = useState({});
    const [isWithdrawn, setIsWithdrawn] = useState(false);
    const [isFromStandard, setIsFromStandard] = useState(false);
    const [istoStandard, setIstoStandard] = useState(false);
    const [isFromDate, setIsFromDate] = useState(false);
    const [isToDate, setIsToDate] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState();
    const [isStudentDeleteModal, setIsStudentDeleteModal] = useState(false);
    const [isStudentModal, setIsStudentModal] = useState(false);
    const [studentTable, setStudentTable] = useState([]);
    const [partnerList, setPartnerList] = useState([]);
    const [jobTypeList, setJobTypeList] = useState([]);
    const [jobTypeCode, setJobTypeCode] = useState("");
    const [ckeditor, setCkeditor] = useState(null);
    const [ckeditor2, setCkeditor2] = useState(null);
    const [radioGroups, setRadioGroups] = useState("");
    const [areaOptions, setAreaOptions] = useState([]);
    const [isSearchProgModal, setIsSearchProgModal] = useState(false);
    const [searchProgModel, setSearchProgModel] = useState({});

    const tableColumns = {
        jobTitle: "job_title",
        vacancies: "vacancies",
    }

    useEffect(() => {
        search(pageSize, 1, "N");
        searchJobType();
        searchWorkLoc();
        searchPartnerList();
        searchPositionType();
        searchTypeList();
        searchUnit();
        searchAllArea();
        ClassicEditor.create(document.querySelector('#editor'), Config.ckEditorConfigWebsite)
            .then(editor => {
                setCkeditor(editor);
            }).catch(error => { console.log(error) });

        ClassicEditor.create(document.querySelector('#editor2'), Config.ckEditorConfigWebsite)
            .then(editor => {
                setCkeditor2(editor);
            }).catch(error => { console.log(error) });
    }, []);

    const searchAllArea = () => {
        Base.callBackApi("commonDropDown/searchAllArea").then((data) => {
            if ("SUCCESS" === data.msg) {
                setAreaOptions(data?.object ?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const searchJobType = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "JOB_TYPE" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setJobTypeList(list ?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const searchWorkLoc = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "WORK_LOCATION" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setWorkLocList(list ?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const searchApplyMethod = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "APPLY_METHOD" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setApplyMethodList(list ?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const searchPositionType = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "POSITION_TYPE" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setPositionTypeList(list ?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const searchTypeList = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "FULL_PART_TIME" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setTypeList(list ?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const searchUnit = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "UNIT" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setUnitList(list ?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const searchPartnerList = () => {
        Base.callBackApi("jobPost/searchPartnerList").then((data) => {
            if ("SUCCESS" === data.msg) {
                setPartnerList(data.object ?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.progCodeList = Config.userInfo?.progCodeList
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("jobPost/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    const closeCohortProgModal2 = (flag, cohortProg) => {
        if (flag) {
            setSearchModel(model => {
                return { ...model, ...{ progId: cohortProg.progId, progCode: cohortProg.progCode, } };
            });
            setCohortProgModel2(cohortProg);
        }
        setIsCohortProgModal2(false);
    }

    const closeSearchProgModal = (flag, cohortProg) => {
        if (flag) {
            setSearchModel(model => {
                return { ...model, ...{ progName: cohortProg.progTitle, progCode: cohortProg.progCode, } };
            });
            setSearchProgModel(cohortProg);
        }
        setIsSearchProgModal(false);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setIsDisabled(false);
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({});
        setCohortProgModel({});
        setJobPostModel({});
        setJobPostStatus("");
        setStudentTable([]);
        setJobTypeCode("");
        setIsDisabled(false);
        ckeditor.setData('');
        ckeditor2.setData('');
        setFlag("add");
        setTabIndex("2");
    }

    const update = (model, e) => {
        messageShowHandler();
        e.stopPropagation();
        searchById(model.jobId);
        setIsDisabled(false);
        setFlag("edit");
        setTabIndex("2");
    }

    const approve = (model, e) => {
        messageShowHandler();
        e.stopPropagation();
        searchById(model.jobId);
        setFlag("approve");
        setTabIndex("2");
        setIsDisabled(true);
        setRadioGroups("");
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            jobId: model.jobId ?? "",
            jobTitle: model.jobTitle ?? "",
            vacancies: model.vacancies ?? null,
            positionType: model.positionType ?? "",
            jobType: model.jobType ?? "",
            partnerId: model.partnerId ?? "",
            progCode: model.progCode ?? "",
            progTitle: model.progTitle ?? "",
            salaryRangeFrom: model.salaryRangeFrom ?? null,
            salaryRangeTo: model.salaryRangeTo ?? null,
            unit: model.unit ?? "",
            expCommenceDate: model.expCommenceDate ? moment(new Date(model.expCommenceDate), Config.dateFormat5) : null,
            expEndDate: model.expEndDate ? moment(new Date(model.expEndDate), Config.dateFormat5) : null,
            workLocId: model.workLocId ? (model.cityId ? [model.cityId + '', model.workLocId + ''] : [model.workLocId + '']) : '',
            // workLocId: model.workLocId ? [model.cityId + '', model.workLocId + ''] : '',
            lastApplyDate: model.lastApplyDate ? moment(new Date(model.lastApplyDate), Config.dateFormat5) : null,
            jobPostStatus: model.jobPostStatus ?? "",
            estimatedNoOfDaysAWeek: model.estimatedNoOfDaysAWeek ?? null,
            estimatedNoOfHoursAWeek: model.estimatedNoOfHoursAWeek ?? null,
            otherDesc: model.otherDesc ?? "",
        });
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        setJobPostModel(model);
        setIsDeleteFrame(true);
        setDeleteTipText("Job Title" + ":" + model.jobTitle + "")
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        clearSelect();
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let model = jobPostModel;
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("jobPost/delete", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const withdrawnOne = (model, e) => {
        e.stopPropagation();
        searchById(model.jobId);
        setFlag("withdrawn");
        setTabIndex("2");
        setIsDisabled(true);
        // setJobPostModel(model);
        // setIsWithdrawn(true);
        // setDeleteTipText("Job Title" + ":" + model.jobTitle + "")
    }

    const withdrawnClose = (state) => {
        if (state) {
            withdrawnData();
        }
        clearSelect();
        setIsWithdrawn(false);
    }

    const withdrawnData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let model = jobPostModel;
        model.menuFuncId = Config.funcInfo.funcId;
        model.jobPostStatus = "WITHDRAWN";
        Base.callBackApi("jobPost/withdrawn", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                // search(pageSize, current, "Y", false);
                searchById(jobPostModel.jobId);
                setFlag("view");
                errFrameShow("success", trans.withdrawnSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const saveDraft = () => {
        setJobPostStatus("DRAFT");
        form.submit();
    }

    const saveSubmit = () => {
        setJobPostStatus("SUBMITTED");
        form.submit();
    }

    const onFinish = (values) => {
        messageShowHandler();
        values.menuFuncId = Config.funcInfo.funcId;
        if (flag === "add") {
            values.jobPostStatus = jobPostStatus;
            values.progId = cohortProgModel.progId;
            values.studentList = studentTable;
            values.jobDesc = ckeditor.getData();
            values.jobRequirement = ckeditor2.getData();
            if (values.workLocId.length < 2) {
                values.workLocId = values.workLocId[0];
            } else {
                values.workLocId = values.workLocId[1];
            }
            setIsLoad(true);
            setSpinInfo(trans.dataBeSaving[Config.backLang])
            Base.callBackApi("jobPost/insert", values).then((data) => {
                if ("SUCCESS" === data.msg) {
                    searchById(data.object);
                    setFlag("edit");
                    errFrameShow("success", trans.saveSuccess[Config.backLang]);
                } else {
                    errFrameShow("error", data.msg);
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        } else if (flag == "edit") {
            values.jobId = jobPostModel.jobId;
            values.lastUpdatedDate = jobPostModel.lastUpdatedDate;
            values.jobPostStatus = jobPostStatus;
            values.progId = cohortProgModel.progId;
            values.studentList = studentTable;
            values.jobDesc = ckeditor.getData();
            values.jobRequirement = ckeditor2.getData();
            if (values.workLocId.length < 2) {
                values.workLocId = values.workLocId[0];
            } else {
                values.workLocId = values.workLocId[1];
            }
            setIsLoad(true);
            setSpinInfo(trans.dataBeSaving[Config.backLang])
            Base.callBackApi("jobPost/update", values).then((data) => {
                if ("SUCCESS" === data.msg) {
                    searchById(data.object);
                    errFrameShow("success", trans.saveSuccess[Config.backLang]);
                } else {
                    errFrameShow("error", data.msg);
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        } else if (flag === "approve") {
            values.jobId = jobPostModel.jobId;
            values.lastUpdatedDate = jobPostModel.lastUpdatedDate;
            values.jobPostStatus = values.auditStatus;
            if (values.workLocId.length < 2) {
                values.workLocId = values.workLocId[0];
            } else {
                values.workLocId = values.workLocId[1];
            }
            setIsLoad(true);
            setSpinInfo(trans.dataBeSaving[Config.backLang])
            Base.callBackApi("jobPost/audit", values).then((data) => {
                if ("SUCCESS" === data.msg) {
                    // cancel();
                    searchById(data.object);
                    setFlag("view");
                    if (values.auditStatus == "ACTIVE") {
                        errFrameShow("success", trans.approvalSuccess[Config.backLang]);
                    } else {
                        errFrameShow("success", trans.rejectSuccess[Config.backLang]);
                    }
                } else {
                    errFrameShow("error", data.msg);
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        }
    }

    const searchById = (jobId) => {
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("jobPost/searchById", jobId).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                initForm(model);
                setJobPostModel(model);
                setCohortProgModel(model);
                let studentList = data.object.studentList ?? [];
                setStudentTable(studentList);
                setJobTypeCode(model?.jobTypeCode ?? "");
                ckeditor.setData(model?.jobDesc ?? "");
                ckeditor2.setData(model?.jobRequirement ?? "");
                // if(model.jobPostStatus == "SUBMITTED") {
                //     setFlag("approve");
                //     setIsDisabled(true);
                // }
                // let jobDesc = model?.jobDesc?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
                // $("#jobDesc").empty().append(jobDesc);
                // let jobRequirement = model?.jobRequirement?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
                // $("#jobRequirement").empty().append(jobRequirement);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const cancel = () => {
        messageShowHandler();
        clearSelect();
        setTabIndex("1");
        setJobPostModel({});
        setCohortProgModel({});
        setJobPostStatus("");
        setStudentTable([]);
        setIsDisabled(false);
        setJobTypeCode("");
        setRadioGroups("");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    const view = (model, e) => {
        messageShowHandler();
        e.stopPropagation();
        searchById(model.jobId);
        setFlag("view");
        setTabIndex("2");
        setIsDisabled(true);
    }

    const studentAdd = () => {
        messageShowHandler();
        setIsStudentModal(true);
    }

    const closeStudentModal = (flag, list) => {
        if (flag) {
            let mergedArray = studentTable.concat(list);
            let uniqueArray = mergedArray.reduce((acc, obj) => {
                let existingObj = acc.find(item => item.assignToUserId === obj.assignToUserId);
                if (!existingObj) {
                    acc.push(obj);
                }
                return acc;
            }, []);
            setStudentTable(uniqueArray)
        }
        setIsStudentModal(false);
    }

    const studentDelete = (index, e, model) => {
        e.stopPropagation();
        setDeleteIndex(index);
        setDeleteTipText("Student ID" + ":" + model.studentAcctId)
        setIsStudentDeleteModal(true);
    }

    const studentDeleteClose = (state) => {
        if (state) {
            setStudentTable(list => {
                list.splice(deleteIndex, 1);
                return [...list];
            });
        }
        setIsStudentDeleteModal(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const uploadClose = (flag) => {
        setIsUpload(false);
    }

    const closeCohortProgModal = (flag, cohortProg) => {
        if (flag) {
            if (cohortProgModel.progId != cohortProg.progId) {
                setStudentTable([])
            }
            form.setFieldsValue({
                progId: cohortProg.progId,
                progCode: cohortProg.progCode,
                progTitle: cohortProg.progTitle,
            });
            setCohortProgModel(cohortProg);
        }
        setIsCohortProgModal(false);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const checkSalaryRangeFrom = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Range From is required.");
        }
        if (Base.isNotEmpty(value)) {
            if (value < 0) {
                return Promise.reject(trans.greaterThan0[Config.backLang]);
            }
            const salaryRangeTo = form.getFieldValue('salaryRangeTo');
            if (Base.isNotEmpty(salaryRangeTo)) {
                if (value > salaryRangeTo) {
                    if (!istoStandard) {
                        setIstoStandard(true);
                        form.validateFields(["salaryRangeTo"]);
                    }
                    return Promise.reject(trans.greaterThan[Config.backLang] + salaryRangeTo);
                }
            } else {
                if (value > 99999999999999) {
                    if (!istoStandard) {
                        setIstoStandard(true);
                        form.validateFields(["salaryRangeTo"]);
                    }
                    return Promise.reject(trans.greaterThan[Config.backLang] + 99999999999999);
                }
            }
        }

        if (istoStandard) {
            form.validateFields(["salaryRangeTo"]);
        }
        setIstoStandard(false);
        return Promise.resolve();
    };

    const checkSalaryRangeTo = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Range To is required.");
        }
        if (Base.isNotEmpty(value)) {
            if (value > 99999999999999) {
                return Promise.reject(trans.greaterThan[Config.backLang] + 99999999999999);
            }
            const salaryRangeFrom = form.getFieldValue('salaryRangeFrom');
            if (Base.isNotEmpty(salaryRangeFrom)) {
                if (value < salaryRangeFrom) {
                    if (!isFromStandard) {
                        setIsFromStandard(true);
                        form.validateFields(["salaryRangeFrom"]);
                    }
                    return Promise.reject(trans.lessThan[Config.backLang] + salaryRangeFrom);
                }
            } else {
                if (value < 0) {
                    if (!isFromStandard) {
                        setIsFromStandard(true);
                        form.validateFields(["salaryRangeFrom"]);
                    }
                    return Promise.reject(trans.greaterThan0[Config.backLang]);
                }

            }
        }
        if (isFromStandard) {
            form.validateFields(["salaryRangeFrom"]);
        }
        setIsFromStandard(false);
        return Promise.resolve();
    };


    const checkStartDate = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Expected Commence Date is required.");
        }
        if (Base.isNotEmpty(value)) {
            const endDate = form.getFieldValue('expEndDate')
            if (Base.isNotEmpty(endDate)) {
                if (Base.afterDate(value, endDate)) {
                    if (!isToDate) {
                        setIsToDate(true);
                        form.validateFields(["expEndDate"]);
                    }
                    return Promise.reject("Expected Commence Date cannot be later than Expected End Date. ")
                }
            }
        }
        if (isToDate) {
            form.validateFields(["expEndDate"]);
        }
        setIsToDate(false);
        return Promise.resolve();
    }

    const checkEndDate = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Expected End Date is required.");
        }
        if (Base.isNotEmpty(value)) {
            const startDate = form.getFieldValue('expCommenceDate')
            if (Base.isNotEmpty(startDate)) {
                if (Base.afterDate(startDate, value)) {
                    if (!isFromDate) {
                        setIsFromDate(true);
                        form.validateFields(["expCommenceDate"]);
                    }
                    return Promise.reject("Expected End Date cannot be earlier than Expected Commence Date.")
                }
            }
        }
        if (isFromDate) {
            form.validateFields(["expCommenceDate"]);
        }
        setIsFromDate(false);
        return Promise.resolve();
    }

    useEffect(() => {
        setJobTypeCode("");
        if (jobTypeId) {
            let model = jobTypeList.find((item) => item.paramId === jobTypeId);
            setJobTypeCode(model?.code ?? "");
        }
    }, [jobTypeId]);

    const radioGroup = (e) => {
        setRadioGroups(e.target.value)
        if (e.target.value === "ACTIVE") {
            form.validateFields(['eventRemark'], { force: true });
        }
    }

    const onChangeAddressA = (value) => {
        // if(value) {
        //     if(value.length < 2 || !value[1]) {
        //         form.setFieldsValue({
        //             workLocId: [],
        //         });
        //     }
        // }
    }

    const checkVacancy = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Number of Vacancy is required.");
        }
        if (value <= 0) {
            return Promise.reject("Number of Vacancy must be greater than 0.");
        }
        return Promise.resolve();
    }

    const checkNoDay = (value) => {
        if (value < 0 || value > 7) {
            return Promise.reject("Only numbers from 0-7 can be filled in");
        }
        return Promise.resolve();
    }

    /*eslint-disable*/
    const columns = [
        {
            title: trans.jobTitle[Config.backLang],
            dataIndex: 'jobTitle',
            className: 'tableWidth11',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobTitle') },
            ellipsis: true,
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className="jobPostContent">{text}</div>
            </Popover>
        },
        {
            title: trans.vacancies[Config.backLang],
            dataIndex: 'vacancies',
            className: 'tableWidth9',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'vacancies') },
        },
        {
            title: trans.industrialPartner[Config.backLang],
            dataIndex: 'companyName',
            className: 'tableWidth16',
        },
        {
            title: trans.programme[Config.backLang],
            dataIndex: 'progCode',
            className: 'tableWidth11',
        },
        {
            title: trans.programmeTitle[Config.backLang],
            dataIndex: 'progTitle',
            className: 'tableWidth13',
            ellipsis: true,
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className="jobPostContent">{text}</div>
            </Popover>
        },
        // {
        //     title: "Job Description",
        //     dataIndex: 'jobDesc',
        //     className: 'tableWidth11',
        //     ellipsis: true,
        //     render: (text) => <Popover content={text} title="" trigger="hover">
        //         <div className = "jobPostContent">{text}</div>
        //     </Popover>
        // },
        // {
        //     title: "Job Requirement",
        //     dataIndex: 'jobRequirement',
        //     className: 'tableWidth12',
        //     ellipsis: true,
        //     render: (text) => <Popover content={text} title="" trigger="hover">
        //         <div className = "jobPostContent">{text}</div>
        //     </Popover>
        // },
        {
            title: trans.salary[Config.backLang],
            dataIndex: 'salaryRangeFrom',
            className: 'tableWidth8',
            render: (text, record) => <div>
                {text && (Base.numberFormat(text) + " ~ " + Base.numberFormat(record.salaryRangeTo))}
            </div>
        },
        {
            title: trans.workLocation[Config.backLang],
            dataIndex: 'workLocVal',
            className: 'tableWidth11',
        },
        {
            title: trans.lastApplyDate[Config.backLang],
            dataIndex: 'lastApplyDate',
            className: 'tableWidth12',
            render: (text) => text ? moment(text).format(Config.dateFormat5) : ""
        },
        {
            title: trans.jobPostStatus[Config.backLang],
            dataIndex: 'jobPostStatus',
            className: 'tableWidth9',
            render: (text) => ContextHandler.getMapValue('jobPostStatusMap', text)
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: 'sysControls ',
            fixed: 'right',
            width: 465,
            render: (text, record) => <div className='operation'>
                {(record.jobPostStatus == "DRAFT" || record.jobPostStatus == "SUBMITTED" || record.jobPostStatus == "REJECTED") && <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>}
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                {record.jobPostStatus == "SUBMITTED" && <div className='sysUpdate' onClick={(e) => approve(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><AuditOutlined /> {trans.approve[Config.backLang]}</div>}
                {(record.jobPostStatus !== "WITHDRAWN" && record.jobPostStatus !== "REJECTED") && <div className='sysDelete' onClick={(e) => withdrawnOne(record, e)} hidden={Config.funcInfo.canDelete === "N"}><RollbackOutlined /> {trans.withdrawn[Config.backLang]}</div>}
                <div className='sysUpdate' onClick={(e) => view(record, e)} hidden={Config.funcInfo.canView === "N"}><EyeOutlined /> {trans.view[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];

    const columnsTwo = [
        {
            title: trans.studentID[Config.backLang],
            dataIndex: 'studentAcctId',
            className: 'tableWidth30',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentAcctId') },
        },
        {
            title: trans.studentName[Config.backLang],
            dataIndex: 'firstName',
            className: 'tableWidth35',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'firstName') },
            render: (text, record) => <div>{text + " " + record.lastName}</div>
        },
        {
            title: trans.email[Config.backLang],
            dataIndex: 'email',
            className: 'tableWidth35',
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            width: 120,
            className: ' sysControls',
            fixed: 'right',
            render: (text, record, index) => <div className='operation'>
                <div className='sysDelete' onClick={(e) => studentDelete(index, e, record)}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
            </div>
        },
    ]
    if (flag !== "add" && flag !== "edit") {
        columnsTwo.splice(3, 1)
    }
    /*eslint-enable*/

    return (
        <div id="container" className="template jobManagement">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {isWithdrawn ? <PopupFrame close={withdrawnClose} content="Are you sure to withdrawn?" deleteTipText={deleteTipText} /> : null}
                    {isStudentDeleteModal ? <PopupFrame close={studentDeleteClose} deleteTipText={deleteTipText} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysSearchRow sysSearchBox'>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.jobTitle[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.jobTitle || ''}
                                                placeholder={trans.jobTitle[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('jobTitle', e.target.value)} />
                                        </div>
                                    </div>
                                    {/* <div className='sysCol'>
                                        <div className="sysTitle">{trans.jobDesc[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.jobDesc || ''}
                                                placeholder={trans.jobDesc[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('jobDesc', e.target.value)} />
                                        </div>
                                    </div> */}
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.programme[Config.backLang]}</div>
                                        <div className="sysButtonSearchInput">
                                            <Input type="text" value={searchModel.progCode || ''} disabled
                                                placeholder={trans.programme[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('progCode', e.target.value)} />
                                        </div>
                                        <Button className="sysBtn btnBlue" onClick={() => { setIsSearchProgModal(true) }}>Select</Button>
                                        <div style={{ marginLeft: '10px' }}>{searchModel.progName}</div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.industrialPartner[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.companyName || ''}
                                                placeholder={trans.industrialPartner[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('companyName', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.jobPostStatus[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Select className='sysSelect'
                                                value={searchModel.jobPostStatus || ''}
                                                onChange={(value) => searchChange('jobPostStatus', value)}>
                                                <Option value=''></Option>
                                                {context.jobPostStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 2300 }}
                                    rowKey="jobId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                        onChange: onChange,                  //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                        total: tablesCount,        //总共多少条数据
                                        current: current,       //当前页
                                        pageSize: pageSize,  //每页显示多少条数据
                                        defaultCurrent: 1,          //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.jobManagement[Config.backLang]} forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                {flag != 'add' &&
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam mustFill">{trans.jobId[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="jobId"
                                                >
                                                    <Input type="text" placeholder={trans.jobId[Config.backLang]} maxLength={20} disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam mustFill">{trans.jobPostStatus[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="jobPostStatus"
                                                    rules={[
                                                        { required: true, message: trans.jobPostStatusIsNoNull[Config.backLang] },
                                                    ]}
                                                >
                                                    <Select className='sysSelect' disabled>
                                                        <Option value=''></Option>
                                                        {context.jobPostStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.jobTitle[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="jobTitle"
                                                rules={[
                                                    { required: true, message: trans.jobTitleIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.jobTitle[Config.backLang]} maxLength={80} disabled={isDisabled} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.vacancies[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="vacancies"
                                                rules={[
                                                    { required: true, validator: (rule, value) => checkVacancy(value) },
                                                ]}
                                            >
                                                <InputNumber className="sysInputNumber" placeholder={trans.vacancies[Config.backLang]}
                                                    precision={0} maxLength={3} disabled={isDisabled} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.positionType[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="positionType"
                                                rules={[
                                                    { required: true, message: trans.positionTypeIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className='sysSelect' disabled={isDisabled}>
                                                    <Option value=''></Option>
                                                    {positionTypeList.map((item) => <Option key={item.paramId} value={item.paramId}>{item.parmValue1}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.jobType[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="jobType"
                                                rules={[
                                                    { required: true, message: trans.jobTypeIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className='sysSelect' onChange={() => form.setFieldsValue({ otherDesc: "" })} disabled={isDisabled}>
                                                    <Option value=''></Option>
                                                    {jobTypeList.map((item) => <Option key={item.paramId} value={item.paramId}>{item.parmValue1}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                {jobTypeCode == "OTHER" ? <div className='sysRow'>
                                    <div className='sysColMax'>
                                        <div className="sysParam">{trans.otherDesc[Config.backLang]}</div>
                                        <div className="sysInputs">
                                            <Form.Item
                                                name="otherDesc"
                                            >
                                                <TextArea maxLength={1000} rows={3} placeholder={trans.otherDesc[Config.backLang]} disabled={isDisabled} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div> : null}

                                <div className="sysRow">
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.programme[Config.backLang]}</div>
                                        <div className={isDisabled ? "sysInput" : "sysInput sysButtonInput"}>
                                            <Form.Item
                                                name="progCode"
                                                rules={[
                                                    { required: true, message: trans.programmeIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" disabled placeholder={trans.programme[Config.backLang]} />
                                            </Form.Item>
                                        </div>
                                        {isDisabled ? "" : <Button className="sysBtn btnBlue" onClick={() => { setIsCohortProgModal(true) }}>Select</Button>}
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.programmeTitle[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="progTitle"
                                                rules={[
                                                    { required: false },
                                                ]}
                                            >
                                                <Input type="text" disabled placeholder={trans.programmeTitle[Config.backLang]} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysRow">
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.salary[Config.backLang]}</div>
                                        <div className="sysInput salaryInput">
                                            <Form.Item
                                                name="salaryRangeFrom"
                                                rules={[
                                                    { required: false, validator: (rule, value) => checkSalaryRangeFrom(value) },
                                                ]}
                                            >
                                                <InputNumber className="sysInputNumber" placeholder="Range From"
                                                    precision={0} maxLength={14} disabled={isDisabled} />
                                            </Form.Item>
                                            ~
                                            <Form.Item
                                                name="salaryRangeTo"
                                                rules={[
                                                    { required: false, validator: (rule, value) => checkSalaryRangeTo(value) },
                                                ]}
                                            >
                                                <InputNumber className="sysInputNumber" placeholder="Range To"
                                                    precision={0} maxLength={14} disabled={isDisabled} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.unit[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="unit"
                                                rules={[
                                                    { required: true, message: trans.unitIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className='sysSelect' disabled={isDisabled}>
                                                    <Option value=''></Option>
                                                    {unitList.map((item) => <Option key={item.paramId} value={item.paramId}>{item.parmValue1}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysRow">
                                    <div className="sysCol">
                                        <div className="sysParam">{trans.estimatedNoOfDaysAWeek[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="estimatedNoOfDaysAWeek"
                                                rules={[
                                                    { required: false, validator: (rule, value) => checkNoDay(value) },
                                                ]}
                                            >
                                                <InputNumber className="sysInputNumber" placeholder={trans.estimatedNoOfDaysAWeek[Config.backLang]}
                                                    precision={0} maxLength={1} disabled={isDisabled} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className="sysCol">
                                        <div className="sysParam">{trans.estimatedNoOfHoursAWeek[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="estimatedNoOfHoursAWeek"
                                                rules={[
                                                    { required: false },
                                                ]}
                                            >
                                                <InputNumber className="sysInputNumber" placeholder={trans.estimatedNoOfHoursAWeek[Config.backLang]}
                                                    precision={0} maxLength={3} disabled={isDisabled} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysRow">
                                    <div className="sysCol">
                                        <div className="sysParam mustFill">{trans.expectDate[Config.backLang]}</div>
                                        <div className="sysInput salaryInput">
                                            <Form.Item
                                                name="expCommenceDate"
                                                rules={[
                                                    { required: true, validator: (rule, value) => checkStartDate(value) },
                                                ]}
                                            >
                                                <DatePicker placeholder={trans.startDate[Config.backLang]}
                                                    className="parts-numberInput datePickerAllWidth"
                                                    format={Config.dateFormat5} disabled={isDisabled} />
                                            </Form.Item>
                                            ~
                                            <Form.Item
                                                name="expEndDate"
                                                rules={[
                                                    { required: true, validator: (rule, value) => checkEndDate(value) },
                                                ]}
                                            >
                                                <DatePicker placeholder={trans.endDate[Config.backLang]}
                                                    className="parts-numberInput datePickerAllWidth"
                                                    format={Config.dateFormat5} disabled={isDisabled} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.lastApplyDate[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="lastApplyDate"
                                                rules={[
                                                    { required: true, message: "Application Deadline is required." },
                                                ]}
                                            >
                                                <DatePicker
                                                    className="parts-numberInput datePickerAllWidth"
                                                    disabledDate={(current) => Base.afterDate(new Date(), current)}
                                                    format={Config.dateFormat5} disabled={isDisabled} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.workLocation[Config.backLang]}</div>
                                        <div className="sysInput">
                                            {/* <Form.Item
                                                name="workLocId"
                                                rules={[
                                                    { required: true, message: trans.workLocationIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className='sysSelect' disabled={isDisabled}>
                                                    <Option value=''></Option>
                                                    {workLocList.map((item) => <Option key={item.paramId} value={item.paramId}>{item.parmValue1}</Option>)}
                                                </Select>
                                            </Form.Item> */}
                                            <Form.Item
                                                name="workLocId"
                                                rules={[
                                                    { required: true, message: trans.workLocationIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Cascader className='sysSelect' disabled={isDisabled}
                                                    options={areaOptions}
                                                    onChange={onChangeAddressA} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.industrialPartner[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="partnerId"
                                                rules={[
                                                    { required: true, message: trans.companyNameIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className='sysSelect' disabled={isDisabled}>
                                                    <Option value=''></Option>
                                                    {partnerList.map((item) => <Option key={item.partnerId} value={item.partnerId}>{item.companyName}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysRow">
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.jobDesc[Config.backLang]}</div>
                                        <div className="sysInputs editor">
                                            <div id="editor" className="editor"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.jobRequirement[Config.backLang]}</div>
                                        <div className="sysInputs editor">
                                            <div id="editor2" className="editor"></div>
                                        </div>
                                    </div>
                                </div>

                                {jobPostModel.jobPostStatus === "REJECTED" ?
                                    <div className='sysRow'>
                                        <div className='sysColMax'>
                                            <div className="sysParam">{trans.rejectReason[Config.backLang]}</div>
                                            <div className="sysInputs">
                                                <TextArea value={jobPostModel.eventRemark} rows={3} placeholder={trans.rejectReason[Config.backLang]} disabled />
                                            </div>
                                        </div>
                                    </div>
                                    : ""}

                                <div className="sysBodyRow">
                                    <div className="userRoleTitleRow">{trans.assignedStudents[Config.backLang]}</div>
                                    <div className="sysBodyRow">
                                        {(flag == "add" || flag == "edit") && <Button className="sysBtnTwo btnBlue" type="primary" hidden={Config.funcInfo.canInsert === "N"} onClick={studentAdd} icon={<PlusCircleOutlined />} >{trans.add[Config.backLang]}</Button>}
                                    </div>
                                </div>
                                <div className="sysTable" id="tableOne">
                                    <Table
                                        scroll={{ x: 1200 }}
                                        rowKey="assignToUserId" //Key值
                                        columns={columnsTwo} //列名
                                        dataSource={studentTable} //数据
                                        pagination={false}
                                    />
                                </div>

                                {flag === "approve" &&
                                    <>
                                        <div className="sysBodyRow">
                                            <div className="userRoleTitleRow">{trans.approveInfo[Config.backLang]}</div>
                                        </div>
                                        <div className='sysRow'>
                                            <div className='sysCol'>
                                                <div className="sysParam mustFill">{trans.approveStatus[Config.backLang]}</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="auditStatus"
                                                        rules={[
                                                            { required: true, message: trans.approveStatusIsNoNull[Config.backLang] }
                                                        ]}
                                                    >
                                                        <Radio.Group onChange={radioGroup}>
                                                            <Radio key="ACTIVE" value="ACTIVE">{trans.approve[Config.backLang]}</Radio>
                                                            <Radio key="REJECTED" value="REJECTED">{trans.reject[Config.backLang]}</Radio>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </div>
                                        {radioGroups === "REJECTED" ?
                                            <div className='sysRow'>
                                                <div className='sysColMax'>
                                                    <div className={"sysParam " + (radioGroups === "REJECTED" ? "mustFill" : "")}>{trans.remarks[Config.backLang]}</div>
                                                    <div className="sysInputs">
                                                        <Form.Item
                                                            name="eventRemark"
                                                            rules={[
                                                                { required: (radioGroups === "REJECTED"), message: trans.eventRemarkIsNoNull[Config.backLang] }
                                                            ]}
                                                        >
                                                            <TextArea maxLength={1000} rows={3} placeholder={trans.remarks[Config.backLang]} />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </div>
                                            : ""}
                                    </>
                                }

                                <div className="sysSaveButton">
                                    {flag == "view" ? "" : (flag === "add" || flag === "edit") ?
                                        <>
                                            {(flag === "add" || jobPostModel?.jobPostStatus == "DRAFT") ? <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />}
                                                onClick={() => saveDraft()}>{trans.saveAsDraft[Config.backLang]}</Button> : ""}
                                            <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckOutlined />}
                                                onClick={() => saveSubmit()}>{trans.submit[Config.backLang]}</Button>
                                        </>
                                        :
                                        (flag === "withdrawn" || jobPostModel?.jobPostStatus == "SUBMITTED") ?
                                            <>
                                                <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<RollbackOutlined />}
                                                    onClick={() => withdrawnData()}>{trans.withdrawn[Config.backLang]}</Button>
                                                {
                                                    flag === "approve" && <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />}
                                                        htmlType="submit">{trans.save[Config.backLang]}</Button>
                                                }
                                            </>
                                            :
                                            <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />}
                                                htmlType="submit">{trans.save[Config.backLang]}</Button>
                                    }
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isUpload && <UploadModal onClose={uploadClose} />}
            {isCohortProgModal && <SelectProgModal onClose={closeCohortProgModal} progModel={cohortProgModel} />}
            {isCohortProgModal2 && <SelectProgModal onClose={closeCohortProgModal2} progModel={cohortProgModel2} />}
            {isSearchProgModal && <SelectProgModal onClose={closeSearchProgModal} progModel={searchProgModel} />}
            {isStudentModal && <SelectStudentModal onClose={closeStudentModal} checkboxState={studentTable ?? []} progModel={cohortProgModel} />}
        </div>
    )

}

export default JobManagement;